export default __webpack_public_path__ + "static/media/category-7.75fc0a7c.svg";